import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.425 4.235a9.1 9.1 0 0 1 13.5655 6.6271c.076.547-.3058 1.0521-.8529 1.1281s-1.0521-.3058-1.1281-.8528a7.0994 7.0994 0 0 0-6.1238-6.0644 7.1 7.1 0 0 0-6.6945 2.9267H8c.5523 0 1 .4477 1 1s-.4477 1-1 1H4.5224a1 1 0 0 1-.0456 0H4c-.5523 0-1-.4477-1-1v-4c0-.5523.4477-1 1-1s1 .4477 1 1v1.2729A9.1 9.1 0 0 1 7.425 4.235m-3.5626 7.7746c.547-.076 1.052.3058 1.128.8529a7.1 7.1 0 0 0 12.8184 3.1376H16c-.5523 0-1-.4477-1-1s.4477-1 1-1h3.4776a1 1 0 0 1 .0456 0H20c.5523 0 1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1v-1.2728a9.099 9.099 0 0 1-8.1416 3.183 9.1 9.1 0 0 1-7.8489-7.7725c-.076-.5471.3058-1.0521.8529-1.1282",
    clipRule: "evenodd"
}), "Refresh", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
